import 'swiper/swiper.scss';
import 'swiper/modules/navigation/navigation.scss';

import { useRef, useState } from 'react';
import classNames from 'classnames';
import { array } from 'prop-types';
import { Navigation } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react/swiper-react';

import CloseBorderedButton from '~/components/ButtonIcons/CloseBorderedButton';
import LootCard from '~/components/CardTemplateView';
import ContentView from '~/components/ContentView';

import style from './LootCardCarousel.module.scss';

function LootCardCarousel({ cardTemplates = [] }) {
  const [selectedCardIndex, setSelectedCardIndex] = useState(0);
  const [showDescription, setShowDescription] = useState(true);
  const navigationPrevRef = useRef(null);
  const navigationNextRef = useRef(null);

  const slidesToShow = 3;
  const infinite = cardTemplates.length > slidesToShow;
  const selectedCard = cardTemplates && cardTemplates[selectedCardIndex];
  const navigationClassName = classNames(style.navigation, {
    [style.hide]: !infinite,
  });
  return (
    <>
      <div className={style.swiperWrapper}>
        <div
          className={classNames(
            'swiper-button-prev',
            navigationClassName,
            style.prev,
          )}
          ref={navigationPrevRef}
        />
        <div
          className={classNames(
            'swiper-button-next',
            navigationClassName,
            style.next,
          )}
          ref={navigationNextRef}
        />
        <Swiper
          modules={[Navigation]}
          slidesPerView={slidesToShow}
          centerInsufficientSlides
          navigation={{
            prevEl: navigationPrevRef.current,
            nextEl: navigationNextRef.current,
          }}
          onSwiper={(swiper) => {
            swiper.params.navigation.prevEl = navigationPrevRef.current;
            swiper.params.navigation.nextEl = navigationNextRef.current;
            swiper.navigation.update();
          }}
          onRealIndexChange={(swiper) => {
            const { realIndex } = swiper;
            setSelectedCardIndex(realIndex);
            setShowDescription(true);
          }}
          loop={infinite}
          slideToClickedSlide
          className={style.LootCardCarousel}
        >
          {cardTemplates.map((cardTemplate, index) => (
            <SwiperSlide
              key={cardTemplate._id || index}
              onClick={() => setShowDescription(true)}
              className={style.card}
            >
              <LootCard cardTemplate={cardTemplate} />
              <button className={classNames('btn', style.infoButton)}>
                {'Info'}
              </button>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
      {selectedCard && showDescription && (
        <div className={style.cardTemplateContent}>
          <div
            className={classNames(
              style.cardIndicator,
              style[`number${cardTemplates.length}`],
              !infinite && style[`selected${selectedCardIndex}`],
            )}
          />
          <CloseBorderedButton
            onClick={() => setShowDescription(false)}
            className={style.iconButton}
          />
          <p>
            <b>{selectedCard.name}</b>
          </p>
          {(selectedCard.content || []).map((c, index) => (
            <ContentView
              {...c}
              key={index}
            />
          ))}
        </div>
      )}
    </>
  );
}

LootCardCarousel.propTypes = {
  cardTemplates: array,
};

export default LootCardCarousel;
